import api from './api';

export const commissionsService = {
  // Get all commissions
  getAll: async (params = {}) => {
    const response = await api.get('/commissions', { params });
    return response.data;
  },

  // Get single commission
  getById: async (id) => {
    const response = await api.get(`/commissions/${id}`);
    return response.data;
  },

  // Submit new commission
  submit: async (commissionData) => {
    const response = await api.post('/commissions', commissionData);
    return response.data;
  },

  // Update commission status (admin only)
  updateStatus: async (id, status, notes) => {
    const response = await api.put(`/commissions/${id}/status`, { status, notes });
    return response.data;
  },

  // Get commission analytics
  getAnalytics: async (params = {}) => {
    const response = await api.get('/commissions/analytics', { params });
    return response.data;
  },

  // Export commissions
  export: async (format = 'csv', params = {}) => {
    const response = await api.get('/commissions/export', {
      params: { ...params, format },
      responseType: 'blob'
    });
    return response.data;
  }
};
